import React, { Component } from "react";
import Default from "./sections/Default";
import Card from "./sections/Card";
import Tariff from "./sections/Tariff";
import Join from "./sections/Join";
import Faq from "./sections/Faq";
import "../../styles/components/ceme/Ceme.scss";
import evioLogo from "../../styles/images/ceme/EVIO_logo.svg";
import mobile_navbar from "../../styles/images/icons/mobile_navbar.svg";
import complainBook from "../../styles/images/ceme/livro_reclamacoes.png";

class Ceme extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      mobileNavCollapsed: false,
    };
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  handleCollapsable() {
    this.safeSetState({
      mobileNavCollapsed: !this.state.mobileNavCollapsed,
    });
  }

  render() {
    return (
      <div id="ceme">
        <div className="nav-bar">
          <div className="item">
            <a href="https://evio.pt/">
              <img src={evioLogo} alt="logo" />
            </a>
          </div>
          <div className="item" />
          <div className="item">
            <div>
              <a href="#section1">Adesão</a>
            </div>
          </div>
          <div className="item">
            <div>
              <a href="#section2">Tarifário</a>
            </div>
          </div>
          <div className="item">
            <div>
              <a href="#section4">Plataforma EVIO</a>
            </div>
          </div>
          <div className="item">
            <div>
              <a href="#section5">FAQ</a>
            </div>
          </div>

          <div className="menu-mobile" onClick={() => this.handleCollapsable()}>
            <img src={mobile_navbar} alt="Nav Icon Mobile" />
          </div>

          {this.state.mobileNavCollapsed ? (
            <div className="navbar-mobile">
              <div className="item">
                <div>
                  <a href="#section1" onClick={() => this.handleCollapsable()}>
                    Adesão
                  </a>
                </div>
              </div>
              <div className="item">
                <div>
                  <a href="#section2" onClick={() => this.handleCollapsable()}>
                    Tarifário
                  </a>
                </div>
              </div>
              <div className="item">
                <div>
                  <a href="#section4" onClick={() => this.handleCollapsable()}>
                    Plataforma EVIO
                  </a>
                </div>
              </div>
              <div className="item">
                <div>
                  <a href="#section5" onClick={() => this.handleCollapsable()}>
                    FAQ
                  </a>
                </div>
              </div>
            </div>
          ) : null}
        </div>

        <a id="section1" href="#section1" className="anchor">
          {null}
        </a>
        <Card />
        <a id="section2" href="#section2" className="anchor">
          {null}
        </a>
        <Tariff />
        <Join />
        <a id="section5" href="#section5" className="anchor-faq">
          {null}
        </a>
        <Faq />

        <div className="footer" style={{ padding: "10px", display: "flex", alignItems: "center", justifyContent: "space-between" }} >

          <a
            href="https://legal.go-evio.com/pt/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Política de Privacidade
          </a>
          <a
            href="https://www.livroreclamacoes.pt/inicio"
            target="_blank"
            rel="noreferrer"
          >
            <img src={complainBook} alt="footer" />
          </a>



        </div>
      </div >
    );
  }
}

export default Ceme;
